import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    isLoggedIn: false,
    hasRights: true,
  },
  reducers: {
    setHasRights: (state, action: PayloadAction<boolean>) => {
      state.hasRights = action.payload;
    },
    setIsLoggedIn: (state, action: PayloadAction<{ isLoggedIn: boolean }>) => {
      state.isLoggedIn = action.payload.isLoggedIn;
    },
  },
});

export const {
  actions: { setHasRights, setIsLoggedIn },
  reducer: authReducer,
} = authSlice;
